import { render, staticRenderFns } from "./ResultSummary.vue?vue&type=template&id=372a7000"
import script from "./ResultSummary.vue?vue&type=script&lang=js"
export * from "./ResultSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports